const config = {
  API_URL: process.env.REACT_APP_API_URL || 'http://localhost:3000/stage',
  GOOGLE_API_KEY: process.env.REACT_APP_GOOGLE_API_KEY || ''
}

export default config
